<template>
    <div v-if="visible" class="custom-select-with-label">
        <label class="float-label">{{ label }} <span v-if="required" class="text-danger">*</span></label>

        <el-select v-model="internalValue" :disabled="!isEditable" filterable :placeholder="placeholder"
            style="width: 100%;" :class="{ 'error-border': errors && errors.length }">

            <template #prefix>
                <component v-if="isComponentIcon" :is="iconComponent" style="font-size: 24px; margin-left: 5px;" />
                <img v-else-if="iconSrc" :src="iconSrc" style="width: 24px; margin-left: 5px;" />
            </template>

            <el-option v-for="option in mappedOptions" :key="String(option.value)" :value="option.value"
                :label="option.label" />

        </el-select>

        <p v-if="errors && errors.length" class="text-danger error">{{ errors[0] }}</p>
    </div>
</template>

<script>
export default {
    name: "SelectWithIcon",
    props: {
        selectedValue: { type: [String, Number], default: null },
        options: { type: Array, default: () => [] },
        visible: { type: Boolean, default: true },
        label: { type: String, default: "Selecione" },
        placeholder: { type: String, default: "Selecione" },
        iconSrc: { type: String, default: null },
        iconComponent: { type: Object, default: null },
        isComponentIcon: { type: Boolean, default: false },
        isEditable: { type: Boolean, default: true },
        errors: { type: Array, default: () => [] },
        required: { type: Boolean, default: true },
    },
    emits: ["update:selectedValue"],
    computed: {
        internalValue: {
            get() {
                if (this.selectedValue === true) return "Sim";
                if (this.selectedValue === false) return "Não";
                return this.selectedValue;
            },
            set(val) {
                if (val === "Sim") this.$emit("update:selectedValue", true);
                else if (val === "Não") this.$emit("update:selectedValue", false);
                else this.$emit("update:selectedValue", val);
            }
        },
        mappedOptions() {
            return (this.options || []).map(option => {
                if (typeof option === "boolean") {
                    return { value: option ? "Sim" : "Não", label: option ? "Sim" : "Não" };
                }

                const value = option.value ?? option.id ?? option;
                let label = option.label ?? option.descricao ?? option.nome ?? option;

                if (typeof label === "boolean") {
                    label = label ? "Sim" : "Não";
                }

                // se value for booleano, converte também
                const finalValue = typeof value === "boolean" ? (value ? "Sim" : "Não") : value;

                return { value: finalValue, label };
            });
        }
    }
    ,
    methods: {
        getOptionValue(option) {
            return option.value ?? option.id ?? option;
        },
        getOptionLabel(option) {
            let label = option.label ?? option.descricao ?? option.nome ?? option;

            if (typeof label === "boolean") {
                return label ? "Sim" : "Não";
            }

            return label;
        }
    },
};
</script>

<style scoped>
.custom-select-with-label {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
}

.float-label {
    position: absolute;
    top: 6px;
    left: 43px;
    font-size: 14px;
    padding: 0 4px;
    z-index: 1;
    color: rgba(0, 0, 0, 0.65);
}

.float-label .text-danger {
    color: #dc3545;
}

.error-border {
    border: 1px solid red !important;
    border-radius: 0.75rem !important;
}

.text-danger {
    text-align: left;
    margin-top: 2px;
    font-size: 0.875rem;
}
</style>
